// extracted by mini-css-extract-plugin
export default {"authMenu":"AuthMenu_authMenu__Pp+j8"};